import FormSubmitProps from "../../../types/FormSubmitProps";
import PersonalMessage from "../AbstractLitigationCase/PersonalMessage";
import { useForm } from "../../../provider/Form/FormProvider";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type EmploymentContractDescriptionProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
  applicationStatus: number;
};

export default function EmploymentContractDescription({ submitProps, product, applicationStatus }: EmploymentContractDescriptionProps) {
  return <PersonalMessage submitProps={submitProps} product={product} applicationStatus={applicationStatus} />;
}
